// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main.estadisticas .caja{
    border: 1px solid #007932;
    border-left: 20px solid #007932;
    border-radius: 20px;
    margin: 12px 0;
    padding: 25px 30px 25px 25px;
    gap: 3px;
}

.main.estadisticas .caja.rojo{
    border: 1px solid #8E151D;
    border-left: 20px solid #8E151D;
}

.main.estadisticas .caja h2,
.main.estadisticas .caja h3{
    line-height: 1.2;
}

.main.estadisticas .caja .numero{ 
    margin-left: 20px;
    font-size: 72px;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/css/Estadisticas.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;IACnB,cAAc;IACd,4BAA4B;IAC5B,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":[".main.estadisticas .caja{\n    border: 1px solid #007932;\n    border-left: 20px solid #007932;\n    border-radius: 20px;\n    margin: 12px 0;\n    padding: 25px 30px 25px 25px;\n    gap: 3px;\n}\n\n.main.estadisticas .caja.rojo{\n    border: 1px solid #8E151D;\n    border-left: 20px solid #8E151D;\n}\n\n.main.estadisticas .caja h2,\n.main.estadisticas .caja h3{\n    line-height: 1.2;\n}\n\n.main.estadisticas .caja .numero{ \n    margin-left: 20px;\n    font-size: 72px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
